/**
 * Exit from an app in three ways.
 *
 * @module app.exit
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

var app   = require('mag-app'),
    exit  = {};


/**
 * Go back to Launcher from an app.
 */
exit.goBack = function () {
    core.call('stop');
};

/**
 * Exit from app.
 * Destroy all application instance.
 * If callback function provided, and callback returns boolean 'true', application will stay alive.
 *
 * @param {Function} [callback] - provide callback if u want to handle exit result, or cancel it
 */
exit.goExit = function ( callback ) {
    var ModalMessage  = require('mag-component-modal'),
        LayoutList    = require('mag-component-layout-list'),
        keys          = require('stb-keys'),
        previousFocus = app.activePage.activeComponent,
        exitModal;

    app.activePage.add(exitModal = new ModalMessage({
        title: gettext('Exit'),
        events: {
            show: function () {
                this.children[0].focus();
            },
            hide: function () {
                previousFocus.focus();
            }
        },
        children: [
            new LayoutList({
                className: 'padded',
                size: 2,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            {
                                value: gettext('Yes')
                            }
                        ],
                        click: function () {
                            if ( typeof callback === 'function' ) {
                                if ( callback(true) ) {
                                    exitModal.hide();
                                    exitModal.remove();

                                    return;
                                }
                            }

                            exitModal.hide();
                            exitModal.remove();

                            app.exit();
                        }
                    },
                    {
                        items: [
                            {
                                value: gettext('No')
                            }
                        ],
                        click: function () {
                            if ( typeof callback === 'function' ) {
                                callback(false);
                            }
                            exitModal.hide();
                            exitModal.remove();
                            app.mainPanelSet.focus();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        if ( event.code === keys.back ) {
                            event.stop = true;
                            if ( typeof callback === 'function' ) {
                                callback(false);
                            }
                            exitModal.hide();
                            exitModal.remove();
                            app.mainPanelSet.focus();
                        }
                    }
                }
            })
        ]
    }));

    exitModal.show();
    exitModal.focus();
};


module.exports = exit;
